import axios from 'axios';

const PORT = process.env.REACT_APP_EXTERNAL_SERVER_PORT || 5000;

const hostName = window.location.hostname;
let hostNameParts = hostName.split('.');
if (hostNameParts.length > 2) {
  hostNameParts[0] =
     process.env.REACT_APP_EXTERNAL_SERVER_SUBDOMAIN;
}
const externalHostname = hostNameParts.join('.');

const urlHost = `${window.location.protocol}//${
  window.location.protocol === 'https:'
    ? externalHostname
    : window.location.hostname + ':' + PORT
}`;

const url = `${urlHost}/flashcards`;
const urlHeaders = `${urlHost}/flashcards/headers`;
const urlBodies = `${urlHost}/flashcards/bodies`;
const urlFlashcardTypes = `${urlHost}/flashcard-types`;
const urlTrainings = `${urlHost}/trainings`;
const urlTests = `${urlHost}/tests`;

export const fetchFlashcardHeaders = () => axios.get(urlHeaders);
export const fetchFlashcards = () => axios.get(url);
export const fetchFlashcard = (id) => axios.get(`${url}/${id}`);
export const fetchFlashcardBody = (id) => axios.get(`${urlBodies}/${id}`);
export const createFlashcard = (newFlashcard) => axios.post(url, newFlashcard);
export const deleteFlashcard = (id) => axios.delete(`${url}/${id}`);
export const updateFlashcard = (id, updatedFlashcard) =>
  axios.patch(`${url}/${id}`, updatedFlashcard);
export const updateFlashcardHeader = (id, updatedFlashcardHeader) =>
  axios.patch(`${urlHeaders}/${id}`, updatedFlashcardHeader);

export const fetchTrainings = () => axios.get(urlTrainings);
export const createTraining = (newTraining) =>
  axios.post(urlTrainings, newTraining);
export const deleteTraining = (id) => axios.delete(`${urlTrainings}/${id}`);
export const updateTraining = (id, updatedTraining) =>
  axios.patch(`${urlTrainings}/${id}`, updatedTraining);

export const fetchFlashcardTypes = () => axios.get(urlFlashcardTypes);
export const createFlashcardType = (newType) =>
  axios.post(urlFlashcardTypes, newType);
export const deleteFlashcardType = (id) =>
  axios.delete(`${urlFlashcardTypes}/${id}`);
export const updateFlashcardType = (id, updatedType) =>
  axios.patch(`${urlFlashcardTypes}/${id}`, updatedType);

export const fetchTests = () => axios.get(urlTests);
export const createTest = (newTest) => axios.post(urlTests, newTest);
